import api from "@/services/api-service";
import querystring from "querystring";

const url = "/aggregations";

const find = (query) => {
  return api().get(`${url}?${querystring.stringify(query)}`);
};

const create = (obj) => {
  return api().post(url, obj);
};

const update = (obj) => {
  return api().put(url, obj);
};

const findByTypeAndName = (type, name) => {
  return api().get(`${url}/name/${type}/${name}`);
};

const findForSequenceByType = (type) => {
  return api().get(`${url}/type/${type}`);
}

export { find, create, findByTypeAndName, findForSequenceByType, update };
